<template>
  <div class="login-page">

    <!-- OVERLAY -->
    <div class="overlay">

      <div class="container h-100">

        <div class="row justify-content-center align-items-center h-100">

          <div class="col-11 col-sm-9 col-md-6 col-lg-4">

            <!-- CARD -->
            <div class="card login-card shadow-lg rounded-4 p-4">

              <!-- HEADER -->
              <div class="text-center mb-4">

                <!-- LOGO DYNAMIQUE -->
                <img
                  v-if="config.logoUrl"
                  :src="config.logoUrl"
                  class="logo-baraka mb-3"
                  alt="Logo"
                >

                <!-- ICON PAR DÉFAUT (si pas de logo configuré) -->
                <div v-else class="baraka-icon mb-3">
                  <i class="bi bi-shop-window"></i>
                </div>

                <h2 class="fw-bold mb-1 title-baraka">
                  {{ config.nom || 'BoutiquePro' }}
                </h2>

                <p class="text-muted small mb-1">
                  POS • Stock • Vente • Mobile Money
                </p>

                <p class="text-muted small mb-0">
                  La gestion intelligente de votre boutique en Afrique
                </p>

              </div>

              <!-- ERROR -->
              <div
                v-if="globalError"
                class="alert alert-danger py-2"
              >
                {{ globalError }}
              </div>

              <!-- FORM -->
              <form @submit.prevent="login" novalidate>

                <!-- EMAIL -->
                <div class="mb-3">

                 <label class="form-label fw-semibold">
  Email ou nom d'utilisateur
</label>

<input
  type="text"
  v-model.trim="email"
  class="form-control form-control-baraka"
  placeholder="ex: admin@boutiquepro.com ou admin"
  autocomplete="username"
/>

                  <div class="invalid-feedback">
                    {{ error.email }}
                  </div>

                </div>

                <!-- PASSWORD -->
                <div class="mb-4">

                  <label class="form-label fw-semibold">
                    Mot de passe
                  </label>

                  <div class="input-group">

                    <input
                      :type="showPassword ? 'text' : 'password'"
                      v-model.trim="password"
                      class="form-control form-control-baraka"
                      :class="{ 'is-invalid': error.password }"
                      placeholder="Votre mot de passe"
                      autocomplete="current-password"
                      :disabled="isLoading"
                    />

                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="showPassword = !showPassword"
                      :disabled="isLoading"
                    >
                      <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>

                  </div>

                  <div class="invalid-feedback d-block">
                    {{ error.password }}
                  </div>

                </div>

                <!-- OPTIONS -->
                <div class="d-flex justify-content-between align-items-center mb-4">

                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="remember"
                      v-model="remember"
                    />
                    <label class="form-check-label" for="remember">
                      Se souvenir de moi
                    </label>
                  </div>

                  <span class="small text-muted">
                    Version 1.0
                  </span>

                </div>

                <!-- BUTTON -->
                <button
                  type="submit"
                  class="btn btn-baraka w-100"
                  :disabled="isLoading"
                >

                  <span
                    v-if="isLoading"
                    class="d-inline-flex align-items-center gap-2"
                  >
                    <span class="spinner-border spinner-border-sm"></span>
                    Connexion...
                  </span>

                  <span v-else>
                    <i class="bi bi-box-arrow-in-right me-2"></i>
                    Se connecter
                  </span>

                </button>

              </form>

            </div>

            <!-- FOOTER -->
            <p class="text-center footer-text mt-3 small mb-0">
              © {{ currentYear }} {{ config.nom || 'BoutiquePro' }} — Tous droits réservés
            </p>

          </div>

        </div>

      </div>

    </div>

    <!-- LOADER -->
    <transition name="fade">
      <div
        v-if="isLoading"
        class="global-loader d-flex align-items-center justify-content-center"
      >

        <div class="text-center">

          <div class="spinner-border text-light" style="width:3rem;height:3rem;"></div>

          <div class="mt-3 text-white">
            Vérification des identifiants...
          </div>

        </div>

      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: "LoginPage",

  data() {
    return {
      email: "",
      password: "",
      remember: false,
      showPassword: false,
      isLoading: false,

      globalError: this.$route.query.message || "",

      error: {
        email: "",
        password: ""
      },

      // 🔥 NOUVEAU : configuration boutique (nom + logo) pour l'affichage
      config: {
        nom: null,
        logoUrl: null
      }
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },

  methods: {

    //  NOUVEAU : appel direct via fetch, sans passer par le wrapper
    // api.js (qui pourrait intercepter un 401 et provoquer une boucle
    // de redirection avant même que l'utilisateur ne soit connecté).
    async fetchConfigPublique() {
  try {
    const baseURL =
      process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";

    // 🔥 CORRIGÉ : route réellement existante dans ConfigurationSysteme
    const res = await fetch(`${baseURL}/api/v1/configurations/entete`);

    if (!res.ok) return;

    const data = await res.json();

    this.config.nom = data.nom || null;

    this.config.logoUrl = data.logo
      ? (data.logo.startsWith("http")
          ? data.logo
          : `${baseURL}${data.logo}`)
      : null;

  } catch (e) {
    console.error("Configuration boutique non disponible", e);
  }
},

    validate() {

  this.globalError = "";

  this.error = {
    email: "",
    password: ""
  };

  if (!this.email) {
    this.error.email = "L'email ou le nom d'utilisateur est requis.";
  }
  // 🔥 Plus de contrainte de format email — le champ accepte
  // aussi bien un email qu'un username, résolu côté backend.

  if (!this.password) {
    this.error.password = "Le mot de passe est requis.";
  }

  return !this.error.email && !this.error.password;
},

    async login() {

      if (!this.validate() || this.isLoading) return;

      this.isLoading = true;
      this.globalError = "";

      try {

        const result = await this.$store.dispatch("authenticate", {
          email: this.email,
          password: this.password,
          remember: this.remember
        });

        if (result.success) {
          this.$router.push("/");
        } else {
          this.globalError = "Identifiants incorrects.";
        }

      } catch (e) {
        this.globalError = "Impossible de se connecter au serveur.";
      } finally {
        this.password = "";
        this.isLoading = false;
      }
    }
  },

  created() {
    this.fetchConfigPublique();
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  width: 100%;
  position: relative;

  background-image: url('@/assets/woman-shopping-thrift-store.jpg');
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,60,40,0.88), rgba(0,0,0,0.72));
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  border: none;
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(8px);
}

.logo-baraka {
  width: 95px;
  height: 95px;
  object-fit: contain;
}

.title-baraka {
  color: #006b4f;
}

.baraka-icon {
  width: 75px;
  height: 75px;
  margin: auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #006b4f, #00996b);
  color: white;
  font-size: 30px;
}

.form-control-baraka {
  height: 52px;
  border-radius: 12px;
  border: 1px solid #d7d7d7;
}

.form-control-baraka:focus {
  border-color: #00996b;
  box-shadow: 0 0 0 4px rgba(0,153,107,0.15);
}

.btn-baraka {
  height: 52px;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  color: white;
  background: linear-gradient(90deg, #006b4f, #00a878);
}

.footer-text {
  color: rgba(255,255,255,0.8);
}

.global-loader {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
}
</style>